import { useState } from "react";
import { Link } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";

import { Box, Divider, Typography, Button } from "@mui/material";

import PictureSelector from "components/PicutreSelector/PictureSelector";

import protectedShopping from "assets/img/compraProtegida.png";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";

import DiscountLogo from "components/DiscountLogo/DiscountLogo";
import CurrencyFormat from "react-currency-format";


export default function MobileViewProduct({ data, dataURL }) {
  const [selected, setSelected] = useState(0);

  const text = {
    fontFamily: "Poppins, sans-serif",
  };

  const whatsapp_float = {
    backgroundColor: "#25d366",
    padding: "15px",
    color: "#FFF",
    borderRadius: "50px",
    fontSize: "28px",
    boxShadow: "2px 2px 3px #999",
    marginRight: "10px",
    display: "flex",
  };

  return (
    <div>
      <Box
        component="div"
        sx={{ display: { xs: "block", sm: "none" } }}
        style={{
          padding: "5px",
          backgroundColor: "white",
          margin: "10px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "10px",
          }}
        >
          {dataURL !== null && (
            <img
              src={dataURL[selected]}
              alt="car"
              style={{
                cursor: "pointer",
                width: "100%",
                height: "250px",
              }}
            />
          )}
          <PictureSelector
            picturesURL={dataURL}
            handleSelector={(index) => setSelected(index)}
          />
        </div>
        <div>
          <div
            style={{
              textAlign: "center", // Center the title text
              fontWeight: "900",
              fontFamily: "Nunito Sans, sans-serif",
            }}
          >
            {data.name}
          </div>
          <Typography
            variant="body1"
            align="center"
            fontSize="13px"
            fontWeight="700"
          >
            {" "}
            {/* Change to align center */}
            <Box component="span" sx={{ color: "primary.main" }}>
              envío GRATIS
            </Box>
            <Box component="span">&nbsp;a partir de $549 en tu carrito</Box>
          </Typography>
          <Typography
            variant="body1"
            align="center"
            fontSize="13px"
            fontWeight="800"
            style={{
              textDecoration: "underline",
              marginTop: "5px",
              marginBottom: "5px",
              letterSpacing: "4px", // Espaciado entre letras
              paddingBottom: "3px",
            }}
          >
            Lista de precios
          </Typography>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <DiscountLogo
              width="150px"
              fontSize="14px"
              discount={data.discountPercentage}
            />
          </div>
          {data.disableOil && (
            <>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "20px",
                }}
              >
                {/* Div centrado con información de precio y botón "COMPRAR AHORA" */}
                <div
                  style={{
                    flexGrow: 1,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <div
                      style={{
                        marginRight: "5px",
                        fontFamily: "Nunito Sans, sans-serif",
                      }}
                    >
                      <CurrencyFormat
                        value={data.price}
                        thousandSeparator={true}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        displayType={"text"}
                        prefix={"$ "} // Agrega el símbolo de $
                        style={{
                          fontSize: data.discount ? "16px" : "17px", // Ajusta el tamaño de la fuente
                          fontWeight: data.discount ? "700" : "900",
                          fontFamily: "Nunito Sans, sans-serif",
                          textDecoration: data.discount
                            ? "line-through"
                            : "none",
                          color: data.discount ? "gray" : "inherit",
                          marginRight: "5px",
                        }}
                      />
                      {data.discount && (
                        <CurrencyFormat
                          value={data.discountPrice}
                          thousandSeparator={true}
                          decimalScale={2}
                          fixedDecimalScale={true}
                          displayType={"text"}
                          prefix={"$ "} // Agrega el símbolo de $
                          style={{
                            fontSize: "16px", // Ajusta el tamaño de la fuente
                            fontWeight: "900",
                            fontFamily: "Nunito Sans, sans-serif",
                            color: "#E21608",
                          }}
                        />
                      )}
                    </div>
                  </div>

                  <Button
                    variant="contained"
                    color="primary"
                    style={{
                      marginTop: "10px",
                      padding: "4px 8px",
                    }}
                    onClick={() => { }}
                  >
                    <Typography
                      sx={{
                        fontSize: "10px",
                        fontWeight: "900",
                        fontFamily: "Nunito Sans, sans-serif",
                        textTransform: "none",
                      }}
                    >
                      COMPRAR AHORA
                    </Typography>
                  </Button>
                </div>

                {/* Botón de carrito alineado a la derecha */}
                <Button
                  variant="contained"
                  color="primary"
                  style={{
                    marginLeft: "auto", // Empuja el botón de carrito a la derecha
                    marginTop: "auto", // Empuja el botón de carrito a la derecha
                    padding: "4px 4px",
                  }}
                >
                  <AddShoppingCartIcon style={{ fontSize: "20px" }} />
                </Button>
              </div>
              <Divider style={{ width: "90vw", borderBottomWidth: "3px" }} />
            </>
          )}
          {!data.disableOil && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center", // Center items
              }}
            >
              {data?.liters?.map((current, idx) => {
                return (
                  <div
                    key={idx} // Added key for mapping
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center", // Center vertically
                      alignItems: "center", // Center horizontally
                      marginTop: "10px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                        marginBottom: "10px",
                      }}
                    >
                      {/* Div centrado con información de precio y botón "COMPRAR AHORA" */}
                      <div
                        style={{
                          flexGrow: 1,
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <div
                            style={{
                              marginRight: "5px",
                              fontFamily: "Nunito Sans, sans-serif",
                            }}
                          >
                            <CurrencyFormat
                              value={current.price}
                              thousandSeparator={true}
                              decimalScale={2}
                              fixedDecimalScale={true}
                              displayType={"text"}
                              prefix={"$ "} // Agrega el símbolo de $
                              style={{
                                fontSize: data.discount ? "16px" : "17px", // Ajusta el tamaño de la fuente
                                fontWeight: data.discount ? "700" : "900",
                                fontFamily: "Nunito Sans, sans-serif",
                                textDecoration: data.discount
                                  ? "line-through"
                                  : "none",
                                color: data.discount ? "gray" : "inherit",
                                marginRight: "5px",
                              }}
                            />
                            {data.discount && (
                              <CurrencyFormat
                                value={current.discountPrice}
                                thousandSeparator={true}
                                decimalScale={2}
                                fixedDecimalScale={true}
                                displayType={"text"}
                                prefix={"$ "} // Agrega el símbolo de $
                                style={{
                                  fontSize: "16px", // Ajusta el tamaño de la fuente
                                  fontWeight: "900",
                                  fontFamily: "Nunito Sans, sans-serif",
                                  color: "#E21608",
                                }}
                              />
                            )}
                          </div>
                          <div
                            style={{
                              fontSize: "17px",
                              color: "black",
                              fontWeight: "",
                              fontFamily: "Nunito Sans, sans-serif",
                            }}
                          >
                            {current.liters} Litros
                          </div>
                        </div>

                        <Button
                          variant="contained"
                          color="primary"
                          style={{
                            marginTop: "10px",
                            padding: "4px 8px",
                          }}
                          onClick={() => { }}
                        >
                          <Typography
                            sx={{
                              fontSize: "10px",
                              fontWeight: "900",
                              fontFamily: "Nunito Sans, sans-serif",
                              textTransform: "none",
                            }}
                          >
                            COMPRAR AHORA
                          </Typography>
                        </Button>
                      </div>

                      {/* Botón de carrito alineado a la derecha */}
                      <Button
                        variant="contained"
                        color="primary"
                        style={{
                          marginLeft: "auto", // Empuja el botón de carrito a la derecha
                          marginTop: "auto", // Empuja el botón de carrito a la derecha
                          padding: "4px 4px",
                        }}
                      >
                        <AddShoppingCartIcon style={{ fontSize: "20px" }} />
                      </Button>
                    </div>

                    <Divider
                      style={{ width: "80vw", borderBottomWidth: "3px" }}
                    />
                  </div>
                );
              })}
            </div>
          )}

          <div
            style={{
              paddingLeft: "15%",
              paddingRight: "15%",
              marginBottom: "20px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={protectedShopping}
              alt="compra protegida"
              style={{ height: "30px", width: "30px", margin: "10px" }}
            />
            <Link
              to="/envios-y-pagos"
              style={{ color: "blue", textDecoration: "none" }}
            >
              Compra protegida
            </Link>
          </div>
          <div
            style={{
              padding: "15px",
            }}
          >
            <div
              style={{
                fontFamily: "Nunito Sans, sans-serif",
                paddingBottom: "10px",
              }}
            >
              El tiempo de entrega del producto estimado es de 2 a 5 días
              hábiles, este puede variar dependiendo el domicilio
            </div>
            <div
              style={{
                fontFamily: "Nunito Sans, sans-serif",
                paddingBottom: "10px",
              }}
            >
              Si desea factura favor de enviar sus datos fiscales al correo{" "}
              <b>afinazone@outlook.com</b>
            </div>
            <div
              style={{
                fontFamily: "Nunito Sans, sans-serif",
                paddingBottom: "10px",
              }}
            >
              Para más detalles{" "}
              <Link
                to="/envios-y-pagos"
                style={{ color: "#E21608", textDecoration: "none" }}
              >
                click aquí
              </Link>
            </div>
          </div>
        </div>
      </Box>
      <Box
        component="div"
        sx={{ display: { xs: "block", sm: "none" } }}
        style={{
          padding: "5px",
          backgroundColor: "white",
          margin: "10px",
        }}
      >
        <Typography
          variant="body1"
          align="center"
          fontSize="16px"
          fontWeight="800"
          style={{
            textDecoration: "underline",
            marginTop: "10px",
          }}
        >
          DESCRIPCIÓN
        </Typography>
        <div
          style={{
            textAlign: "left",
            padding: "0 10px 10px 10px",
            ...text,
          }}
        >
          <ReactMarkdown
            remarkPlugins={[remarkGfm]}
            rehypePlugins={[rehypeRaw]}
          >
            {data.description}
          </ReactMarkdown>
        </div>
      </Box>
      <Box
        component="div"
        sx={{ display: { xs: "block", sm: "none" } }}
        style={{ fontSize: "13px", margin: "20px" }}>
        CÓDIGO UPC: {data.upcCode}
      </Box>

      <Box
        component="div"
        sx={{ display: { xs: "block", sm: "none" } }}
        style={{
          padding: "5px",
          backgroundColor: "white",
          margin: "10px",
        }}
      >
        <div
          style={{
            textAlign: "center",
            fontFamily: "Nunito Sans, sans-serif",
          }}
        >
          ¿TIENES DUDAS SOBRE EL ENVÍO, LA COMPATIBILIDAD O DISPONIBILIDAD DEL
          PRODUCTO?
        </div>

        <div style={{ display: "flex", justifyContent: "center" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              flexWrap: "wrap",
            }}
          >
            <a
              href="https://wa.me/524613126256 "
              style={whatsapp_float}
              target="_blank"
              rel="noopener noreferrer"
            >
              <WhatsAppIcon style={{ height: "30px", width: "30px" }} />
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    fontFamily: "Poppins, sans-serif",
                    fontSize: "12px",
                  }}
                >
                  Atención a clientes
                </div>
                <div
                  style={{
                    fontFamily: "Poppins, sans-serif",
                    textDecoration: "none",
                    fontSize: "20px",
                  }}
                >
                  461-312-6256
                </div>
              </div>
            </a>
          </div>
        </div>
      </Box>
    </div>
  );
}
